// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","bottomFooter":"App_bottomFooter__V8M8e"};